(function() {
    'use strict';

    angular.module('appliances')
        .controller('AppliancesListController', AppliancesListController);

    AppliancesListController.$inject = ['$state', 'appliancesDataSrvc', 'appliancesSrvc', 'notificationSrvc', 'appliancesMessagesConst', 'appliancesPermissionsConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function AppliancesListController($state, appliancesDataSrvc, appliancesSrvc, notificationSrvc, appliancesMessagesConst, appliancesPermissionsConst, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.appliancesRows = [];
        self.appliancesCols = [{
            title: 'Obraz',
            value: 'icon',
            type: 'image'
        }, {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opis',
            value: 'description',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = appliancesPermissionsConst;
        self.searchQuery = {
            name: null,
            description: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getAppliances();
        }

        function getAppliances(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    description: self.searchQuery.description,
                    ordering: self.searchQuery.ordering
                };
            }
            return appliancesDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.appliancesRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getAppliances);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.appliances.create');
        }

        function onEdit(row) {
            $state.go('layout.appliances.update', { pk: row.pk });
        }

        function onDelete(row) {
            return appliancesSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", appliancesMessagesConst.delete);
                lodashService.remove(self.appliancesRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getAppliances();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getAppliances();
        }
    }
})();
